import { render } from "./SVGHanger.vue?vue&type=template&id=43021f1c"
import script from "./SVGHanger.vue?vue&type=script&lang=js"
export * from "./SVGHanger.vue?vue&type=script&lang=js"

import exportComponent from "/home/tachyon/wardrobe-test3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__